import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import SubCategory from "../SubCategory/SubCategory";
import { setShowAllNum } from "../../Redux/Actions";

const Category = (props) => {
  let mainCategory;
  let subCategory;
  const [mainCategories, setMainCategories] = useState([]);
  const [category, setCategory] = useState([]);
  const [showThirdCat, setShowThirdCat] = useState(false);
  const [showSubCat, setShowSubCat] = useState(false);
  const [api, setApi] = useState("");
  const [categoryNum, setCategoryNum] = useState();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  useEffect(() => {
    setMainCategories([
      {
        categoryName: "روغن موتور",
        isActive: false,
        apiName: "LubricatingOil",
      },
      {
        categoryName: "لاستیک",
        isActive: false,
        apiName: "Tire",
      },
      {
        categoryName: "لوازم یدکی",
        isActive: false,
        apiName: "SpareParts",
      },
      // {
      //   categoryName: "مراکز خدماتی",
      //   isActive: false,
      //   apiName: "ServiceComplex",
      // },
    ]);
    localStorage.removeItem("categoryNum");
  }, []);

  const openSubCategory = (e, api, id) => {
    setShowSubCat(true);
    mainCategory = document.querySelectorAll(".mainCategory");
    for (let k = 0; k < mainCategory.length; k++) {
      mainCategory[k]?.classList.remove("active");
    }
    e.target.classList.add("active");

    // let categories = document.querySelectorAll(".subs");
    // categories.forEach((item) => {
    //   item.classList.remove("active");
    // });
    axios
      .get(
        `Product/GetProductCategory/${api}`,
        user[0]?.token && {
          headers: {
            Authorization: `Bearer ${user[0]?.token}`,
          },
        }
      )
      .then((result) => {
        setApi(api);
        if (api === "Tire") {
          setCategoryNum(0);
          dispatch(setShowAllNum(0));
        } else if (api === "LubricatingOil") {
          setCategoryNum(2);
          dispatch(setShowAllNum(2));
        } else if (api === "SpareParts") {
          setCategoryNum(1);
          dispatch(setShowAllNum(1));
        } else if (api === "ServiceComplex") {
          setCategoryNum(3);
          dispatch(setShowAllNum(3));
          // props.history.push("/markets");
        }
        setCategory(result.data.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
    setShowThirdCat(false);
    // let filtered = [...categories].filter((i) => i.innerText === "همه");
    // filtered[0].click();
    // if (categoryNum >= 0) {
    //   localStorage.setItem("categoryNum", categoryNum);
    // } else {
    //   localStorage.removeItem("categoryNum");
    // }
    props.history.replace({
      pathname: `/products`,
      state: { categoryId: null },
    });
  };
  const openMarket = (e) => {
    setShowSubCat(false);
    mainCategory = document.querySelectorAll(".mainCategory");
    for (let k = 0; k < mainCategory.length; k++) {
      mainCategory[k]?.classList.remove("active");
    }
    e.target.classList.add("active");

    // let categories = document.querySelectorAll(".subs");
    // categories.forEach((item) => {
    //   item.classList.remove("active");
    // });
    setShowThirdCat(false);
    props.history.push("/markets");
  };

  const setShowThirdCategory = (bool) => {
    setShowThirdCat(bool);
  };

  return (
    <div className="menuItemSubMenu">
      <div className="rightSide">
        <div className="mainCategories">
          {mainCategories.map((item, index) => {
            return (
              <span
                key={index}
                // className={`mainCategory item${index + 1} ${item.isActive && "active"}`}
                className={`mainCategory item${index + 1}`}
                onClick={(e) => openSubCategory(e, item.apiName, item.id)}
              >
                {item.categoryName}
              </span>
            );
          })}
          {/* <span
            className={`mainCategory item${100 + 1}`}
            onClick={(e) => {
              openMarket(e);
            }}
          >
            مراکز خدماتی
          </span> */}
        </div>
      </div>
      {/* {showSubCat && ( */}
      <div className={`leftSide ${showSubCat ? "showSubs" : ""}`}>
        <div className="subCategories">
          <SubCategory
            showAll={() => openSubCategory(api, "همه")}
            subCategory={category}
            categoryNum={categoryNum}
            setShowThirdCategory={setShowThirdCategory}
            showThirdCategory={showThirdCat}
          />
        </div>
      </div>
      {/* )} */}
    </div>
  );
};

export default React.memo(withRouter(Category));
